import { useState } from "react";
import { Abas, Aviso, PainelDaAba } from "../componentes/ui";
import { PainelDeConfiguracao } from "../componentes/pesquisas/PainelDeConfiguracao";
import { PainelDeEnvios } from "../componentes/pesquisas/PainelDeEnvios";
import { PainelDeResultados } from "../componentes/pesquisas/PainelDeResultados";
import { podeNaSessao, useSessao } from "../nucleo/sessao";
import { useTitulo } from "../nucleo/titulo";

type Aba = "resultados" | "configuracao" | "envios";

/** Pesquisas de satisfação: resultado (NPS/CES), configuração e convites enviados. */
export function Pesquisas() {
  useTitulo("Pesquisas de satisfação");
  const sessao = useSessao();
  const [escolhida, setEscolhida] = useState<Aba | null>(null);

  if (!sessao.data) {
    return (
      <p className="lead" role="status">
        Verificando o seu acesso…
      </p>
    );
  }
  const veResultados = podeNaSessao(sessao.data, "pesquisa:resultados");
  const gerencia = podeNaSessao(sessao.data, "pesquisa:gerenciar");
  if (!veResultados && !gerencia) {
    return (
      <Aviso tom="marca" data-testid="pesquisas-sem-permissao">
        As pesquisas de satisfação são mantidas pela equipe da GEOvendas.
      </Aviso>
    );
  }
  const abas = [
    ...(veResultados ? [{ chave: "resultados" as const, rotulo: "Resultados" }] : []),
    ...(gerencia
      ? [
          { chave: "configuracao" as const, rotulo: "Configuração" },
          { chave: "envios" as const, rotulo: "Convites" },
        ]
      : []),
  ];
  const ativa: Aba = escolhida ?? abas[0]?.chave ?? "resultados";

  return (
    <div data-testid="pesquisas">
      <h1 className="titulo-pagina">Pesquisas de satisfação</h1>
      <p className="lead mb-4">
        NPS e CES depois do atendimento: o convite sai por e-mail quando o chamado é resolvido, e o
        cliente responde por um link, sem login.
      </p>
      <Abas<Aba> rotulo="Pesquisas" id="pesquisas" itens={abas} ativa={ativa} aoSelecionar={setEscolhida} className="mb-4" />
      <PainelDaAba id="pesquisas" chave="resultados" ativa={ativa} data-testid="painel-resultados">
        <PainelDeResultados />
      </PainelDaAba>
      <PainelDaAba id="pesquisas" chave="configuracao" ativa={ativa} data-testid="painel-configuracao">
        <PainelDeConfiguracao />
      </PainelDaAba>
      <PainelDaAba id="pesquisas" chave="envios" ativa={ativa} data-testid="painel-envios">
        <PainelDeEnvios />
      </PainelDaAba>
    </div>
  );
}
